import { injectable } from "inversify";
import { Dispatch } from "redux";
import { ActionTypes, IShowLoadingAction } from "./LoadingActionTypes";

export interface ILoadingAction {
    isLoading(value?: boolean): any;
}

@injectable()
export class LoadingAction implements ILoadingAction {
    public isLoading(value?: boolean) {
        return (dispatch: Dispatch<IShowLoadingAction>) => {
            dispatch({
                type: ActionTypes.IS_LOADING,
                data: value
            });
        };
    }
}


// WEBPACK FOOTER //
// ./src/Store/Loading/LoadingAction.tsx